import React from 'react';
import cx from 'classnames';
import Typography from '@material-ui/core/Typography';
import withStyles from 'isomorphic-style-loader/withStyles';

import { Interweave } from 'interweave';
import s from './LessonSources.scss';

const LessonSources = (
  { className, isSourcesExist, headerTitle, sourcesHTML }, // eslint-disable-line react/prop-types
) =>
  isSourcesExist ? (
    <div className={cx(s.sourcesContainer, className)}>
      <Typography component="h3" variant="h5">
        {headerTitle}
      </Typography>
      <Interweave tagName="div" content={sourcesHTML} />
    </div>
  ) : null;

export default withStyles(s)(LessonSources);
